import { ROUTE } from "../../routes";
export const goBackAction = async (action, _datastore, { navigate }) => {
    const fromRouteId = action?.payload?.value;
    if (fromRouteId === "ManageLimit") {
        await navigate(ROUTE.MANAGE_LIMIT);
    }
    else if (fromRouteId === "PLEDGE_HISTORY") {
        await navigate(ROUTE.PLEDGE_HISTORY);
    }
    else if (fromRouteId === "VIEW_DETAILS") {
        await navigate(ROUTE.VIEW_PORTFOLIO_DETAIL);
    }
    else {
        await navigate(ROUTE.DASHBOARD);
    }
};
export const needHelpAction = async (action, _datastore, { navigate }) => {
    await navigate(ROUTE.CONTACT_US_CARD);
};
export const doneAction = async (action, _datastore, { navigate, network }) => {
    const fromRouteId = action?.payload?.value;
    if (fromRouteId === "ManageLimit") {
        await navigate(ROUTE.MANAGE_LIMIT);
    }
    else if (fromRouteId === "PLEDGE_HISTORY") {
        await navigate(ROUTE.PLEDGE_HISTORY);
    }
    else if (fromRouteId === "VIEW_DETAILS") {
        await navigate(ROUTE.VIEW_PORTFOLIO_DETAIL);
    }
    else {
        await navigate(ROUTE.DASHBOARD);
    }
};
